import { render, staticRenderFns } from "./businessesRecruit.vue?vue&type=template&id=274883dc&"
import script from "./businessesRecruit.vue?vue&type=script&lang=js&"
export * from "./businessesRecruit.vue?vue&type=script&lang=js&"
import style0 from "./businessesRecruit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports